import React, { useState, useEffect } from 'react'
import Header from './components/Header'
import WebcamFeed from './components/WebcamFeed'
import EmotionDisplay from './components/EmotionDisplay'
import EmotionHistory from './components/EmotionHistory'
import LoadingIndicator from './components/LoadingIndicator'
import { loadFaceApiModels } from './utils/faceApiLoader'
import './App.css'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [modelsLoaded, setModelsLoaded] = useState(false)
  const [isWebcamActive, setIsWebcamActive] = useState(false)
  const [currentEmotion, setCurrentEmotion] = useState(null)
  const [emotionHistory, setEmotionHistory] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    const initializeApp = async () => {
      try {
        setIsLoading(true)
        await loadFaceApiModels()
        setModelsLoaded(true)
        setError(null)
      } catch (err) {
        console.error('Failed to load face-api.js models:', err)
        setError('Failed to initialize emotion detection models. Please refresh the page.')
      } finally {
        setIsLoading(false)
      }
    }

    initializeApp()
  }, [])

  const handleEmotionDetected = (emotion) => {
    if (emotion && emotion.emotion !== currentEmotion?.emotion) {
      const timestamp = new Date().toISOString()
      const newEmotionEntry = {
        ...emotion,
        timestamp,
        id: Date.now()
      }
      
      setCurrentEmotion(emotion)
      setEmotionHistory(prev => [newEmotionEntry, ...prev.slice(0, 49)]) // Keep last 50 entries
    }
  }

  const handleWebcamToggle = (active) => {
    setIsWebcamActive(active)
    if (!active) {
      setCurrentEmotion(null)
    }
  }

  const clearHistory = () => {
    setEmotionHistory([])
  }

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (error) {
    return (
      <div className="app">
        <Header />
        <div className="error-container">
          <div className="error-message">
            <h2>Initialization Error</h2>
            <p>{error}</p>
            <button 
              onClick={() => window.location.reload()}
              className="retry-button"
              aria-label="Retry loading the application"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <div className="content-grid">
          <div className="webcam-section">
            <WebcamFeed
              isActive={isWebcamActive}
              onToggle={handleWebcamToggle}
              onEmotionDetected={handleEmotionDetected}
              modelsLoaded={modelsLoaded}
            />
          </div>
          
          <div className="emotion-section">
            <EmotionDisplay 
              emotion={currentEmotion}
              isActive={isWebcamActive}
            />
          </div>
        </div>
        
        <div className="history-section">
          <EmotionHistory 
            history={emotionHistory}
            onClear={clearHistory}
            isActive={isWebcamActive}
          />
        </div>
      </main>
    </div>
  )
}

export default App 